import ms from 'ms';
import { gql } from '@soundxyz/gql-string';
import { fetchQuery, MerkleProofDocument } from '@graphql/reactQuery';
import { isHexList } from './hex';

/*#__PURE__*/ gql(/* GraphQL */ `
  query MerkleProof($root: String!, $unhashedLeaf: String!) {
    merkleTreeProof(root: $root, unhashedLeaf: $unhashedLeaf) {
      proof
    }
  }
`);

export async function getMerkleProof({
  merkleRoot,
  userAddress,
}: {
  merkleRoot: string;
  userAddress: string;
}) {
  const { data } = await fetchQuery(MerkleProofDocument, {
    variables: {
      root: merkleRoot,
      unhashedLeaf: userAddress,
    },
    retry: 5,
    staleTime: Infinity,
    cacheTime: ms('1 hour'),
  });

  if (!data?.merkleTreeProof || !isHexList(data.merkleTreeProof.proof)) return null;

  return data.merkleTreeProof.proof;
}
